import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, KeyRound } from 'lucide-react';
import api from '../lib/api';
import { PlatformPasswordFields, passwordError } from './PlatformPasswordFields';

export const PlatformPasswordChange = ({ onDone, onCancel, forced = true, email }) => {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setError(''); setSaved(false);
    if (form.next !== form.confirm) return setError('Passwords do not match');
    setBusy(true);
    try {
      await api.post('/users/me/change-password', { current_password: form.current, new_password: form.next });
      setForm({ current: '', next: '', confirm: '' }); setSaved(true);
      if (onDone) await onDone();
    } catch (err) { setError(passwordError(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className={forced ? 'pc-shell pc-login-shell' : 'pc-account-password'} data-testid="pc-password-change">
      <form className={forced ? 'pc-login-card' : 'pc-password-form'} onSubmit={submit} data-testid="pc-password-change-form">
        <h1 className="pc-h1" data-testid="pc-pw-title">{forced ? 'Choose your own password' : 'My password'}</h1>
        {email && <p className="pc-password-email" data-testid="pc-pw-account">{email}</p>}
        <p className="pc-sub" data-testid="pc-pw-session-note">{forced ? 'Replace your temporary password to continue.' : 'Your other sessions will be signed out.'}</p>
        <PlatformPasswordFields form={form} setForm={setForm} busy={busy}
          currentLabel={forced ? 'Temporary password' : 'Current password'} />
        <Link className="pc-password-link" to="/platform/forgot-password" data-testid="pc-pw-recovery-link">Forgot password? Reset by email</Link>
        {error && <p className="pc-password-error" role="alert" data-testid="pc-pw-error">{error}</p>}
        {saved && <p className="pc-password-success" role="status" data-testid="pc-pw-success">Password updated. Your other sessions have been signed out.</p>}
        <button className="pc-btn pc-btn-primary pc-login-submit" disabled={busy} data-testid="pc-pw-submit">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <KeyRound className="h-3.5 w-3.5" />}
          {busy ? 'Saving…' : 'Save password'}
        </button>
        <button type="button" className="pc-btn" disabled={busy} onClick={onCancel} data-testid="pc-pw-signout">{forced ? 'Sign out' : 'Back to console'}</button>
      </form>
    </div>
  );
};